export default {
    computed: {
        isDevEnv()
        {
            return process.env.NODE_ENV === "development";
        }
    }
}